import { render, staticRenderFns } from "./ChatsView.vue?vue&type=template&id=22ed192e&scoped=true&"
import script from "./ChatsView.vue?vue&type=script&lang=ts&"
export * from "./ChatsView.vue?vue&type=script&lang=ts&"
import style0 from "./ChatsView.vue?vue&type=style&index=0&id=22ed192e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ed192e",
  null
  
)

export default component.exports